import messages from "../../locale/messages";
import {
  inputTextLimit,
  inputDescLimit,
  containsMalicious,
} from "../../helpers/textRestriction";

const validateStep2 = (values) => {
  const errors = {};

  if (!values.title) {
    errors.title = messages.required;
  } else if (values.title && values.title.trim() == "") {
    errors.title = messages.required;
  } else if (values?.title?.length > inputTextLimit) {
    errors.title = messages.inputFieldRestriction;
  } else if (containsMalicious(values.title)) {
    errors.title = messages.invalidInput;
  }

  if (!values.description) {
    errors.description = messages.required;
  } else if (values.description && values.description.trim() == "") {
    errors.description = messages.required;
  } else if (values?.description?.length > inputDescLimit) {
    errors.description = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.description)) {
    errors.description = messages.invalidInput;
  }
  
  if (values.captionTitle) {
    if (values.captionTitle.length > 100) {
      errors.captionTitle = messages.maxCaptionLimit;
    } else if (containsMalicious(values.captionTitle)) {
      errors.captionTitle = messages.invalidInput;
    }
  }

  if (values.captionTitle && !values.photo) {
    errors.photo = messages.captionImage.defaultMessage;
  }

  return errors;
};

export default validateStep2;
